import { render, staticRenderFns } from "./benefits-carousel.vue?vue&type=template&id=46271f3a&scoped=true&"
import script from "./benefits-carousel.vue?vue&type=script&lang=js&"
export * from "./benefits-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46271f3a",
  null
  
)

export default component.exports